import { render, staticRenderFns } from "./FooterBtn.vue?vue&type=template&id=2e2a0595&scoped=true"
import script from "./FooterBtn.vue?vue&type=script&lang=js"
export * from "./FooterBtn.vue?vue&type=script&lang=js"
import style0 from "./FooterBtn.vue?vue&type=style&index=0&id=2e2a0595&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a0595",
  null
  
)

export default component.exports